import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { RouteLoadingBar } from "../../components";

export const RootLayout: FC = () => (
  <>
    <RouteLoadingBar />
    <main className="h-full">
      <Outlet />
    </main>
  </>
);
